import React, { useEffect, useState } from "react";
import { IS_PRERENDER } from "@/lib/faro";

const WORDS = ["FORMACIÓN VIAL", "PERMISO B", "MOTO A2", "CAMIÓN C", "AUTOBÚS D", "CAP", "CUADRICICLO AML", "PERMISO POR PUNTOS"];

const Group = ({ ariaHidden }) => (
  <span className="inline-flex" aria-hidden={ariaHidden || undefined}>
    {WORDS.map((w) => (
      <span key={w} className="font-display font-black tracking-tighter text-4xl sm:text-6xl uppercase px-8 inline-flex items-center">
        {w}
        <span className="mx-8 text-[var(--faro-yellow)]">✳</span>
      </span>
    ))}
  </span>
);

export default function EditorialMarquee() {
  // The seamless-loop clone is added client-side only, so the prerendered HTML
  // (what crawlers read) contains each word exactly once.
  const [cloned, setCloned] = useState(false);
  useEffect(() => {
    if (!IS_PRERENDER) setCloned(true);
  }, []);

  return (
    <section className="bg-[var(--faro-red)] text-white py-8 sm:py-12 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <div className="faro-marquee whitespace-nowrap" style={{ animationDuration: "45s" }}>
        <Group />
        {cloned && <Group ariaHidden />}
      </div>
    </section>
  );
}
